<template>
    <div v-loading="loading" class="suobi-chongzhi">
        <div class="chongzhi-card">
            <div class="card-header">
                <div class="tit">选择充值数额</div>
            </div>
            <div class="card-body">
                <div class="amount-list">
                    <div v-for="(item, index) in list.arr" :key="index" :class="list.active == index ? 'active' : ''"
                        @click="list.active = index">
                        <div class="amount">{{ item }}</div>
                        <span class="label">缩币</span>
                        <span class="price">￥{{ item }}.00</span>
                    </div>
                </div>
                <div class="custom-input">
                    <el-input placeholder="请输入自定义充值金额" v-model="price" clearable>
                    </el-input>
                </div>
                <div class="pay-methods">
                    <span class="method-item" @click="pay('wxpay')">
                        <span class="icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path
                                    d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c4.801 0 8.692-3.287 8.692-7.342 0-4.054-3.891-7.339-8.692-7.339z" />
                            </svg>
                        </span>
                        <span>微信支付</span>
                    </span>
                    <span class="method-item" @click="pay('alipay')">
                        <span class="icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                            </svg>
                        </span>
                        <span>支付宝</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="instructions-card">
            <div class="card-header">
                <div class="tit">缩水网充值说明</div>
            </div>
            <div class="card-body">
                <ul>
                    <li>1. 不能购彩和提现，仅用于查看缩水师推荐缩水单，技巧师推荐EXCEL表、软件交易师的软件以及投注站帮扶中心众筹招股，最少充值100元(1元=1缩币)</li>
                    <li>2. 微信客服：hzck36886</li>
                    <li>3. 微信月限额5000元，支付宝月限额1000元。额度用完后，可以用银行汇款转账到公司其他账号继续充值</li>
                    <li>4. 银行汇款转账方式充值：我们收到汇款后，管理员会帮您充值缩币</li>
                    <li>5. 查询记录：请在个人中心查看缩币记录</li>
                    <li>6. 欢迎联系我们(8:30-21:30)，夜间21:30~8:30无人工客服，请微信或QQ留言</li>
                </ul>
            </div>
        </div>

        <el-dialog :visible.sync='qrCode.show' :title="''" :show-header="false" width="520px">
            <div class="qr-container">
                <div class="pay-header">
                    <div class="pay-title">{{ payTitle }}</div>
                    <div class="pay-desc">请使用{{ payTitle === '微信支付' ? '微信' : '支付宝' }}扫描二维码支付</div>
                </div>
                <div class="amount-display">支付金额：{{ price || list.arr[list.active] }}元</div>
                <div class="qr-wrapper">
                    <div ref="qrcode" class="qr-code"></div>
                </div>
                <div class="tips">
                    <div class="tip-title">温馨提示</div>
                    <div class="tip-content">支付成功后系统会自动为您充值，请耐心等待...</div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { balance } from '@/api/chongzhi'
import QRCode from 'qrcodejs2';
export default {
    data() {
        return {
            payTitle: '',
            price: '',
            list: {
                active: 0,
                arr: [5, 15, 30, 50, 100, 200, 500, 1000]
            },
            qrCode: {
                show: false,
                url: ''
            },
            loading: false,

            socket: null, // Socket连接对象

            ws: {},
        }
    },
    mounted() {


    },
    beforeDestroy() {
        // this.socket.disconnect(); // 断开Socket连接
    },
    methods: {
        pay(payType) {

            let params = `/${this.vuex_token}?userId=${this.vuex_userInfo.userId}&businessType=pay`
            // console.log('process.env.VUE_APP_BASE_WS', process.env);
            this.ws = new WebSocket(process.env.VUE_APP_BASE_WS + '/stage-api/pay-websocket' + params)
            this.ws.onopen = function (event) {
                console.log("WebSocket is open now.");
            };
            let that = this
            this.ws.onmessage = function (event) {
                console.log("Message from server ", event.data);
                let { code, msg } = JSON.parse(event.data)
                if (code == 200) {
                    that.qrCode.show = false
                }
                // if (msg == '连接已建立') {
                // that.$message.success(msg)
                // }
                if (msg == '支付成功') {
                    that.$alert(msg, '提示', {
                        confirmButtonText: '确定',
                    });
                    that.price = ''
                }
            }


            this.loading = true
            balance({
                money: this.price || this.list.arr[this.list.active],
                // money: 0.01,
                payType,
                userName: this.vuex_userInfo.nickName,
                returnUrl: 'http://www.baidu.com'
            }).then(res => {
                this.loading = false
                this.qrCode.show = true

                this.payTitle = payType == 'wxpay' ? '微信支付' : '支付宝支付'

                this.$nextTick(_ => {
                    const container = this.$refs.qrcode;
                    while (container.firstChild) {
                        container.removeChild(container.firstChild);
                    }
                    new QRCode(this.$refs.qrcode, {
                        text: res.data.codeUrl,
                        width: 128 * 2,
                        height: 128 * 2
                    });
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.suobi-chongzhi {
    width: 100%;
    box-sizing: border-box;

    .chongzhi-card,
    .instructions-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        margin-bottom: 20px;

        .card-header {
            background: linear-gradient(135deg, #2899DF 0%, #1a7fc4 100%);
            padding: 14px 20px;

            .tit {
                color: #fff;
                font-weight: bold;
                font-size: 16px;
            }
        }

        .card-body {
            padding: 20px;
        }
    }

    .amount-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 15px;
        margin-bottom: 20px;

        >div {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px 10px;
            background: #FFB74D;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.02);
            }

            &.active {
                background: #E92728;
            }

            .amount {
                font-size: 24px;
                font-weight: bold;
                color: #fff;
            }

            .label {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.85);
                margin-top: 4px;
            }

            .price {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.9);
                margin-top: 6px;
            }
        }
    }

    .custom-input {
        margin-bottom: 25px;

        :deep(.el-input__wrapper) {
            border-radius: 8px;
            border-color: #e8e8e8;
            transition: all 0.3s;

            &:focus-within {
                border-color: #2899DF;
                box-shadow: 0 0 0 2px rgba(40, 153, 223, 0.1);
            }
        }
    }

    .pay-methods {
        display: flex;
        gap: 50px;

        .method-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 12px 50px;
            background: #409eff;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                opacity: 0.9;
            }

            .icon {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;

                svg {
                    width: 20px;
                    height: 20px;
                }
            }

            span:last-child {
                font-size: 16px;
                color: #fff;
                font-weight: 500;
            }
        }
    }

    .instructions-card {
        background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        margin-bottom: 20px;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .tit {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 0.5px;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
        }

        .card-body {
            padding: 24px;

            ul {
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                    line-height: 2;
                    font-size: 14px;
                    color: #4a5568;
                    padding-left: 22px;
                    position: relative;
                    margin-bottom: 12px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    &::before {
                        content: '✓';
                        position: absolute;
                        left: 0;
                        color: #409eff;
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
            }
        }
    }

    .qr-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        min-height: 450px;
        background: linear-gradient(180deg, #f5f7fa 0%, #fff 50%);
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

        .pay-header {
            width: 100%;
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 50%, #1e7de4 100%);
            padding: 30px;
            text-align: center;
            position: relative;
            overflow: hidden;

            &::before {
                content: '';
                position: absolute;
                top: -50%;
                right: -20%;
                width: 100px;
                height: 100px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 50%;
            }

            &::after {
                content: '';
                position: absolute;
                bottom: -30%;
                left: -15%;
                width: 80px;
                height: 80px;
                background: rgba(255, 255, 255, 0.08);
                border-radius: 50%;
            }

            .pay-title {
                font-size: 24px;
                font-weight: 600;
                color: #fff;
                margin-bottom: 8px;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
                letter-spacing: 1px;
            }

            .pay-desc {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.9);
                font-weight: 400;
            }
        }

        .amount-display {
            font-size: 32px;
            font-weight: 700;
            color: #E92728;
            margin-bottom: 25px;
            padding: 20px 40px;
            background: linear-gradient(135deg, #fff5f5 0%, #ffeaea 100%);
            border-radius: 16px;
            border: 2px solid #ffd6d6;
            box-shadow: 0 4px 16px rgba(233, 39, 40, 0.15);
            position: relative;
            top: -10px;

            &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 4px;
                right: 4px;
                bottom: 4px;
                border: 1px dashed rgba(233, 39, 40, 0.2);
                border-radius: 12px;
            }
        }

        .qr-wrapper {
            background: #fff;
            padding: 30px;
            border-radius: 16px;
            box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
            margin-bottom: 20px;
            border: 1px solid #e8eef3;
            transition: transform 0.3s ease, box-shadow 0.3s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
            }

            .qr-code {
                width: 260px;
                height: 260px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fff;
                border-radius: 8px;
            }
        }

        .tips {
            text-align: center;
            padding: 20px 30px;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border-radius: 12px;
            width: 90%;
            box-sizing: border-box;
            border: 1px solid #e2e8f0;
            margin-bottom: 20px;

            .tip-title {
                font-size: 14px;
                font-weight: 600;
                color: #334155;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;

                &::before {
                    content: '💡';
                    font-size: 14px;
                }
            }

            .tip-content {
                font-size: 13px;
                color: #64748b;
                line-height: 1.8;
            }
        }
    }
}
</style>
